mutation CreateRestreamDestination(
  $contentId: ID!
  $input: CreateRestreamDestinationInput!
) {
  createRestreamDestination(contentId: $contentId, input: $input) {
    id
  }
}
